



































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import SearchInput from "@/components/SearchInput.vue";
import BackButton from "@/components/BackButton.vue";
import CardListCard from "@/components/Admin/CardListCard.vue";
import CardModal from "@/components/Admin/CardModal.vue";

import { pinboardService } from "@/services/pinboard.service";
import { PinBoard } from '@/models/PinBoard.model';
import store from "@/store/store";
import { cardService } from '../../services/card.service';
import { CardModel } from '../../models/card.model';


@Component({
    components : {
        SearchInput,
        BackButton,
        CardListCard,
        CardModal
    }
})
export default class AdminCard extends Vue{
    filterWeek:boolean = true;
    filterMonth:boolean = false;
    isModalVisible:boolean = false;
    cards:CardModel[] = [];
    cardId:number = 0;

    searchQuery:string = "";

    async created(){
        this.load();
    }

    async load(){
        this.cards = await cardService.getAll(this.$store.getters["app/companyId"]);
        console.log(this.cards);
    }

    edit(id:number){
        this.cardId = id;
        this.isModalVisible = true;
    }

    async remove(id:number){
        var r = confirm("Sure you want to delete?");
        if (r == true) {
            cardService.delete(id).then((result) => {
                // this.$store.dispatch("app/getCompanyInfoFromKey", store.getters["auth/companyKey"]);
                this.load();
                this.$notify({
                    group: 'message',
                    title: 'Succe!',
                    text: 'Tavla borttaget',
                    duration: 5000,
                    type: 'success',
                });
            });
        }
    }

    get filteredList(){
        let filterList = this.cards;
        if(this.searchQuery != "" && this.searchQuery.length > 1){
            filterList = filterList.filter(c => c.name!.toLowerCase().startsWith(this.searchQuery.toLowerCase()));
        }

        return filterList;
    }

    openModal(){
        this.cardId = 0;
        this.isModalVisible = true;
    }

    modalEvent(obj:any,id:any){
        this.isModalVisible = obj == "close" || obj == "saved" ? false : true;
        this.cardId = id != undefined ? id : this.cardId;
        if(obj="saved")
            this.load();
    }


    
}
